import React from 'react'
import { DialogContent as MuiDialogContent } from '@mui/material'
import ThemeConfig from '../../theme/ThemeConfig'

const DialogContent = props => {
  return <MuiDialogContent theme={ThemeConfig} children={props.children} />
}

export default DialogContent
